module.exports = __webpack_public_path__ + "static/media/graphic-element-1.963aeaa4.svg";